/**
 * @generated SignedSource<<89c076efb5250f3f035759a421a3a901>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_viewer">;
  readonly " $fragmentType": "PdpRespShippingReturns_viewer";
};
export type PdpRespShippingReturns_viewer$key = {
  readonly " $data"?: PdpRespShippingReturns_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e6645c30db664a11b5995acb1599f071";

export default node;
